/**
 * PageSection - Flush content section (hairline divider, no Paper panel)
 */

import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const SectionRoot = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(0.5),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

/**
 * @param {Object} props
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.subtitle]
 * @param {React.ReactNode} props.children
 */
const PageSection = ({ title, subtitle, children, ...rest }) => (
  <SectionRoot data-testid="page-section" {...rest}>
    {title && (
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 700 }}
      >
        {title}
      </Typography>
    )}
    {subtitle && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {subtitle}
      </Typography>
    )}
    {children}
  </SectionRoot>
);

export default PageSection;
